import React from 'react'
import ModalWebhook from "./modal-webhook"
import Webhook from "../../../../../core/model2/webhook/webhook-v2/webhook"

type Params = {
    webhook?    : Webhook
    onSaved?    : callback     // (webhook) => void
}

export default function modalAddWebhook(params?: Params) {
    gd.modal.showV5(
        <ModalWebhook webhook = {params?.webhook}
                      onSaved = {params?.onSaved}/>
    )
}
